import { Pagination } from '../../../model/paginatiion';
import { IPublicationResponse } from '../../../model/base/response/publication-response';
import { ICategoryPublicationResponse } from '../../../model/base/response/category-publication-response';
import { ISubcategoryPublicationResponse } from '../../../model/base/response/subcategory-publication-response';
import { IPublishingVehicleResponse } from '../../../model/base/response/publishing-vehicle-response';

export type PublicationsState = {
    publications: Pagination<IPublicationResponse>;
    categories: ICategoryPublicationResponse[];
    subcategories: ISubcategoryPublicationResponse[];
    publishingVehicles: IPublishingVehicleResponse[];
    loading: boolean;
    loadingFilters: boolean;
};

export enum ACTION_TYPES {
    setPublications = 'setPublications',
    clearPublications = 'clearPublications',
    setCategories = 'setCategories',
    setSubcategories = 'setSubcategories',
    setPublishingVehicles = 'setPublishingVehicles',
    setLoading = 'setLoading',
    setLoadingFilters = 'setLoadingFilters',
}

export const PublicationsReducer = (state: PublicationsState, action: any): PublicationsState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setPublications:
            return {
                ...state,
                publications: payload,
                loading: false,
            };
        case ACTION_TYPES.clearPublications:
            return {
                ...state,
                publications: new Pagination<IPublicationResponse>(),
            };
        case ACTION_TYPES.setCategories:
            return {
                ...state,
                categories: payload,
                loadingFilters: false,
            };
        case ACTION_TYPES.setSubcategories:
            return {
                ...state,
                subcategories: payload,
            };
        case ACTION_TYPES.setPublishingVehicles:
            return {
                ...state,
                publishingVehicles: payload,
            };
        case ACTION_TYPES.setLoading:
            return {
                ...state,
                loading: payload,
            };
        case ACTION_TYPES.setLoadingFilters:
            return {
                ...state,
                loadingFilters: payload,
            };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
}
